import { render, staticRenderFns } from "./DemoRegister.vue?vue&type=template&id=e90bc7e2"
import script from "./DemoRegister.vue?vue&type=script&lang=js"
export * from "./DemoRegister.vue?vue&type=script&lang=js"
import style0 from "./DemoRegister.vue?vue&type=style&index=0&id=e90bc7e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports